import React, { Component } from 'react';
import CardWidget from "../card-widget/CardWidget";
import CardWidgetContent from "../card-widget/CardWidgetContent";

class LockedInitialization extends Component {

    getTAUserLockedContent = () => {
        return (
            <div>
                <CardWidgetContent contentText="student_section.locked" />
            </div>
        )
    };

    render() {
        return (
            <CardWidget getCardContent={this.getTAUserLockedContent} />
        )
    };
}

export default LockedInitialization;